import React from 'react';
import { createArray } from '../_utils';
var TableSkeleton = function (props) {
    var _a = props.columns, columns = _a === void 0 ? 5 : _a, _b = props.rows, rows = _b === void 0 ? 5 : _b, _c = props.isResponsive, isResponsive = _c === void 0 ? false : _c;
    var tableClass = function () {
        var className = 'table table-hover table-condensed table-bordered';
        if (isResponsive)
            className += ' table-responsive';
        return className;
    };
    var columnWidth = function (index) {
        var widths = ['25', '100', '75', '50'];
        return 'w-' + (widths[index % 4] || '75');
    };
    return (React.createElement("div", null,
        React.createElement("table", { id: "s-table", className: tableClass() },
            React.createElement("thead", null,
                React.createElement("tr", null, createArray(columns).map(function (i) { return (React.createElement("th", { key: i },
                    React.createElement("span", { className: "skeleton-line skeleton-h-md skeleton-header" }))); }))),
            React.createElement("tbody", { className: "stable-row" }, createArray(rows).map(function (item) { return (React.createElement("tr", { key: item, className: "stable-row" }, createArray(columns).map(function (i) { return (React.createElement("td", { key: i },
                React.createElement("span", { className: "skeleton-line skeleton-h-md " + columnWidth(i - 1 + item) }))); }))); })))));
};
export default React.memo(TableSkeleton);
